"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import configStore from "../stores/configStore";
export default function saveConfig() {
  const mapElements = document.getElementsByClassName("js-decidimgeo");
  if (mapElements.length < 1) {
    console.warn("no map config for this page");
    return void 0;
  }
  const mapElement = mapElements[0];
  const configString = mapElement.getAttribute("data-config");
  const i18nConfigString = mapElement.getAttribute("data-i18n");
  const config = JSON.parse(configString);
  const i18nConfig = JSON.parse(i18nConfigString);
  const { setConfig } = configStore.getState();
  return setConfig(__spreadProps(__spreadValues({}, config), { mapID: mapElement.id, i18n: i18nConfig }));
}
